import { BaseModel } from "sjs-base-model";

export default class MenuModel extends BaseModel {
    public readonly idVoceMenu: number = 0;
    public readonly codiceContenuto: string = "";
    public readonly idContenuto: number = 0;
    public readonly idElemento: number = 0;
    public readonly titolo: string = "";
    public readonly path: string = "";

    constructor(data: Partial<MenuModel>) {
        super();

        this.update(data);
    }
}
